import axios from "./config";

// const PATH_ROUTER_API = process.env.VUE_APP_env === "dev" ? "/api" : "";

const PATH_ROUTER_API =
  process.env.VUE_APP_env === "dev" ? "http://10.0.10.209:8099" : process.env.VUE_APP_API_ROOT;

const index = {
  //日志更新
  //用户首次登陆通知系统更新
  firstNotice(params){
    return axios.get(`${PATH_ROUTER_API}/v1/version_notice/get`, params);
  },
  //更新系统更新日志
  updateLog(params){
    return axios.post(`${PATH_ROUTER_API}/v1/version/update`,params);
  },
  //获取日志列表
  logList(params){
    return axios.get(`${PATH_ROUTER_API}/v1/version/get`,params);
  },
  //新增系统更新日志
  newLog(params){
    return axios.post(`${PATH_ROUTER_API}/v1/version/add`,params);
  },
  //删除系统更新日志
  deleteLog(params){
    return axios.get(`${PATH_ROUTER_API}/v1/version/delete`,params);
  },
    // 发出-回复留言
  createRemainMessage(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/chat/insert`, params);
  },
  // 查询留言
  getRemainMessage(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/chat/get`, params);
  },
  // 根据 id 查询留言
  getRemainMessageById(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/group_chat/get`, params);
  },
  // 删除留言
  deleteRemainMessage(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/chat/display`, params);
  },
  // 留言标记已读
  readRemainMessage(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/chat/read`, params);
  },
  // 设置留言记录为热门
  setHotChat(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/chat_hot/set`, params);
  },
  // 获取热门
  getHotChat(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/chat_hot/get`, params);
  },
  // 留言详情
  lookUpRemainMessageDetail(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/chat/getDetail`, params);
  },
  // 回复留言
  answerRemainMessage(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/chatDetail/insert`, params);
  },
  // 获取本单位上下级
  getSelfUnitStructure(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/remain/unit`, params);
  },
  // 档案-报表-材料查询
  getArchives(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/archives/search`, params);
  },
  // 用户登录
  login(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/user/login/pw`, params);
  },
  // 发送短信验证码 type: 0：审批，1：申请，2：上报，3：登录
  sendSms(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/sendsms`, params);
  },
  // 手机号登录
  telLogin(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/user/login/sms`, params);
  },
  // reqID登录
  reqIdLogin(params){
    return axios.post(`${PATH_ROUTER_API}/v1/user/login/szgh`, params);
  },
  // 验证码验证
  checkVerifyCode(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/report/sms`, params);
  },
  //请选择您要登录的单位
  getUnitArray(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/user/login/smsTwo`, params);
  },
  // 获取父单位信息
  getFatherOrg(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/father_org/get`, params);
  },

  // 获取用户信息
  userInfo(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/gyl/user/info`, params);
  },
  // 上传文件接口
  upload(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/file_record/upload`, params);
  },
  // 删除附件
  deleteFile(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/file_record/delete`, params);
  },
  // 获取菜单列表
  getMenu(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/menu/get`, params);
  },
  // 新增菜单
  addMenu(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/menu/add`, params);
  },
  // 编辑菜单
  editMenu(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/menu/update`, params);
  },
  // 删除菜单
  deleteMenu(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/menu/delete`, params);
  },
  // 新增菜单权限
  addMenuPermission(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/menu/operation/add`, params);
  },
  // 选择权限
  choicePermission(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/menu/operation/choice`, params);
  },
  // 获取菜单权限
  getMenuPermission(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/menu/operation/get`, params);
  },
  // 获取操作权限列表
  getOperationPermission(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/menu/operation_list/get`, params);
  },
  // 删除菜单权限
  deleteMenuPermission(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/menu/operation/delete`, params);
  },
  // 删除操作权限
  deleteOperationPermission(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/operation/delete`, params);
  },
  // 获取单位
  getCoType(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/co_type/get`, params);
  },

  // 单位禁用/启用
  departDisable(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/org/disable`, params);
  },
  // 获取本单位信息
  getUnitInfo(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/unit/get`, params);
  },

  // 更新本单位信息（用于保存）
  updateUnitInfo(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/unit/update`, params);
  },

  // 申请更改单位信息
  changeUnitInfo(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/unit/change`, params);
  },

  // 获取监管单位
  getUnitExt(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/unit_ext/get`, params);
  },

  // 更新单位监管
  updateUnitExt(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/unit_ext/update`, params);
  },

  // 新增单位性质
  addCoType(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/co_type/add`, params);
  },
  // 编辑单位性质
  editCoType(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/co_type/update`, params);
  },
  // 删除单位性质
  deleteCoType(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/co_type/delete`, params);
  },

  // 单位性质 类别 服务关系
  getUnitProp(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/unit_prop/getAll`, params);
  },

  // 获取角色
  getRole(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/role/get`, params);
  },

  // 新增角色
  addRole(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/role/add`, params);
  },
  // 更新角色
  editRole(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/role/update`, params);
  },

  // 删除角色
  deleteRole(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/role/delete`, params);
  },

  // 获取角色权限
  getRolePermission(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/role/operation/get`, params);
  },

  // 更新角色权限
  editRolePermission(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/role/operation/update`, params);
  },
  // 新增用户
  addUser(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/user/add`, params);
  },
  // 更新用户
  updateUser(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/user/update`, params);
  },
  // 获取单位用户列表
  getUserList(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/user_list/get`, params);
  },
  // 获取用户信息
  getUser(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/user/get`, params);
  },

  // 删除用户
  deleteUser(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/user/delete`, params);
  },

  // 获取单位层级
  getOrg(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/org/get`, params);
  },
  // 获取单位层级
  loadOrg(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/org_url/get`, params);
  },
  addOrg(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/org/add`, params);
  },
  editOrg(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/org/update`, params);
  },
  deleteOrg(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/org/delete`, params);
  },

  adjustOrg(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/org/adjust_position`, params);
  },
  /**
   * 生成报表
   */
  //上报目录查询接口
  getSelect(params) {
    return axios.get(
      `${PATH_ROUTER_API}/v1/report_for_approval/select`,
      params
    );
  },
  getUnit(params) {
    return axios.get(
      `${PATH_ROUTER_API}/v1/report_generation_unit_number/get`,
      params
    );
  },
  getCreateTable(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/report_generation/get`, params);
  },
  getCreateTableOne(params) {
    return axios.get(
      `${PATH_ROUTER_API}/v1/report_generation_estate/get`,
      params
    );
  },
  // 下载报表
  getDownlaod(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/batch_table/download`, params);
  },
  getDelete(params) {
    //上报目录删除操作
    return axios.get(
      `${PATH_ROUTER_API}/v1/report_for_approval/delete`,
      params
    );
  },
  getEdit(params) {
    //上报目录 编辑
    return axios.get(`${PATH_ROUTER_API}/v1/assets_debt/get`, params);
  },
  getList(params) {
    //获取上报审批目录
    return axios.get(`${PATH_ROUTER_API}/v1/report_for_approval/get`, params);
  },
  // 获取上报审核统计数字
  getshangbaoNumber(params) {
    return axios.get(
      `${PATH_ROUTER_API}/v1/report_for_approval_num/get`,
      params
    );
  },
  getShanBao(params) {
    //上报 审批
    return axios.post(
      `${PATH_ROUTER_API}/v1/report_for_approval/update`,
      params
    );
  },
  InsertOther(params) {
    //新增其他 上报、保存
    return axios.post(`${PATH_ROUTER_API}/v1/report_other/insert`, params);
  },
  getOtherEdit(params) {
    //上报目录 新增其他编辑
    return axios.get(`${PATH_ROUTER_API}/v1/report_other/get`, params);
  },
  // 查看单位信息更改
  lookUpUnitInoChange(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/unit/getChangeDetail`, params);
  },
  // 查看单位信息更改历史记录
  lookUpUnitInoChangeHistory(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/unit/getChangeHistory`, params);
  },
  // 资产负债上报  4、行政机关 1、事业单位 5、企业
  getAssetsDebt(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/assets_debt/get`, params);
  },
  // 收支状况
  getIncome(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/institution_balance/get`, params);
  },
  // 获取经营
  getManagement(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/operating_condition/get`, params);
  },
  // 获取业务  6-16
  getBusiness(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/main_business/get`, params);
  },
  // 获取人员
  getPersonnel(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/personnel_situation/get`, params);
  },

  // 资产负债更新 事业
  updateCareerAssets(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/institution_assets_debt/update`,
      params
    );
  },

  //测试环境
  editionMaster(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/personalize/set`, params);
  },
  //获取当前权限
  getEdition(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/personalize/get`, params);
  },
  //使用指南获取内容
  getContent(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/instruction/get`, params);
  },
  //使用指南保存
  contentSave(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/instruction/update`, params);
  },

  // 资产负债更新 行政
  updateAdministrationAssets(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/administrative_unit_assets_debt/update`,
      params
    );
  },
  // 资产负债更新 企业
  updateEnterprisingAssets(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/enterprise_assets_debt/update`,
      params
    );
  },

  // 收支状况更新
  updateIncome(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/institution_balance/update`,
      params
    );
  },

  // 经营状况更新
  updateManagement(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/operating_condition/update`,
      params
    );
  },

  //  学校业务状况更新
  updateSchoolServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/school_main_business/update`,
      params
    );
  },

  //  工人文化宫业务状况更新
  updateCulrureServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/palace_main_business/update`,
      params
    );
  },

  //  工人体育馆业务状况更新
  updateSportServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/stadium_main_business/update`,
      params
    );
  },

  // 新闻出版演艺单位业务状况更新
  updateNewsPublishServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/press_publication_main_business/update`,
      params
    );
  },

  // 工人疗休养院业务状况更新
  updateRestServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/sanatorium_main_business/update`,
      params
    );
  },

  // 俱乐部业务状况更新
  updateClubServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/club_main_business/update`,
      params
    );
  },

  // 职工旅行社业务状况更新
  updateTravelServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/travel_agency_main_business/update`,
      params
    );
  },

  // 宾馆饭店业务状况更新
  updateHotelServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/hotel_main_business/update`,
      params
    );
  },

  // 职工互助保障组织业务状况更新
  updateHelpOrganizationServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/ms_org_main_business/update`,
      params
    );
  },

  // 基金会业务状况更新
  updateFoundationServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/foundation_main_business/update`,
      params
    );
  },

  // 工会帮扶中心（职工服务中心）业务状况更新
  updateHelpCenterServe(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/staffSc_main_business/update`,
      params
    );
  },

  //人员状况更新
  updatePersonal(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/personnel_situation/update`,
      params
    );
  },
  // 更新用户密码
  updatePassword(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/user_pw/update`, params);
  },

  // 获取房屋土地列表
  getBuildLandList(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/building_land_list/get`, params);
  },

  // 房屋土地详情获取
  getBuildLandDetail(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/building_land/get`, params);
  },

  // 添加房屋信息
  addBuild(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/building/add`, params);
  },

  // 更新房屋信息
  updateBuild(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/building/update`, params);
  },

  // 删除房屋信息
  delBuild(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/building/delete`, params);
  },

  // 添加土地信息
  addLand(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/land/add`, params);
  },

  // 更新土地信息
  updateLand(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/land/update`, params);
  },

  // 删除土地信息
  delLand(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/land/delete`, params);
  },

  // 更新房屋土地附件信息
  updateBuildLandFile(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/building_land_file/update`,
      params
    );
  },

  // 新增变更信息
  addBuildLandChange(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/building_land_change/add`, params);
  },

  // 获取变更信息
  getBuildLandChange(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/building_land_change/get`, params);
  },

  // 申请房屋变更 数据缓存
  submitBuildChangeCache(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/building_change_cache/update`,
      params
    );
  },

  // 申请土地变更 数据缓存
  submitLandChangeCache(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/land_change_cache/update`, params);
  },

  // 获取房屋缓存数据
  getBuildChangeCache(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/building_change_cache/get`, params);
  },

  // 获取土地缓存数据
  getLandChangeCache(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/land_change_cache/get`, params);
  },
  // 重置房屋数据
  updatetBuildChangeCache(params) {
    return axios.get(
      `${PATH_ROUTER_API}/v1/building_change_choice/update`,
      params
    );
  },
  // 重置土地数据源
  updatetLandChangeCache(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/land_change_choice/update`, params);
  },
  // 房屋综合批量上报接口
  houseBatchUpdate(params) {
    return axios.post(
      `${PATH_ROUTER_API}/v1/building_land_batch/update`,
      params
    );
  },
  // 生成报表模板
  createTableTemplate(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/unit_table_class/get`, params);
  },
  // 获取公告分类列表
  getAnnounceCategory(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/notice_type/get`, params);
  },
  // 编辑公告分类
  updateAnnounceCategory(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/notice_type/update`, params);
  },
  // 删除、批量删除公告分类
  deleteAnnounceCategory(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/notice_type/delete`, params);
  },
  // 新增公告分类
  addAnnounceCategory(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/notice_type/insert`, params);
  },
  // 获取公告列表
  getAnnouncements(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/notice/getByType`, params);
  },
  // 根据ID获取单条公告
  getAnnouncementByID(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/notice/getDetailById`, params);
  },
  // 查询公告列表
  selectAnnouncements(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/notice/select`, params);
  },
  // 删除、批量删除公告
  deleteAnnouncements(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/notice/delete`, params);
  },
  // 更新公告
  updateAnnouncement(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/notice/update`, params);
  },
  // 新增公告
  insertAnnouncement(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/notice/insert`, params);
  },
  // 获取填报任务配置
  getReportFormAssignmentsConfig(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/report_config/get`, params);
  },
  // 新增填报任务
  addReportFormAssignmentsConfig(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/report_config/insert`, params);
  },
  // 删除填报任务
  deleteReportFormAssignmentsConfig(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/report_config/delete`, params);
  },
  // 编辑填报任务
  updateReportFormAssignmentsConfig(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/report_config/update`, params);
  },
  // 获取我的上报任务
  getMyAssignments(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/report_task/select`, params);
  },
  // 获取任务报送情况
  getReportAssignmentsProgress(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/asset_report/situation`, params);
  },
  // 获取单位最新任务报送年份
  getLatestAssignmentsYear(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/new_year_task/get`, params);
  },
  // 日志查询
  getlogger(params) {
    return axios.post(`${PATH_ROUTER_API}/v1/logger/get`, params);
  },
  //首页卡片数字
  getHomePageNumber(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/home_page_analysisI/get`, params);
  },
  // 获取BI地图数据
  getBIRegion(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/region_data/get`, params);
  },
  // 获取BI分析数据
  getAnalysis(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/analysis_assets_data/get`, params);
  },
  // 获取BI工人文化宫数据
  getPalace(params) {
    return axios.get(`${PATH_ROUTER_API}/v1/palace_assets/get`, params);
  },
  getAnalysisRegion(params) {
    return axios.get(
      `${PATH_ROUTER_API}/v1/analysis_assets_region/get`,
      params
    );
  }
};

export default index;
